import React from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />

      <main className="legal-page">
        <div className="legal-container">
          <div className="legal-hero">
            <span className="legal-chip">Legal</span>
            <h1>Privacy Policy</h1>
            <p className="legal-intro">
              This Privacy Policy explains how Simba Solution collects, uses,
              stores, and protects information when you visit our website or use our services.
            </p>
            <p className="legal-date">Last updated: May 19, 2026</p>
          </div>

          <div className="legal-card">
            <section className="legal-block">
              <h2>1. Who We Are</h2>
              <p>
                Simba Solution is a UK-based company dedicated to digital
                solutions for the logistics and freight forwarding industries.
              </p>
            </section>

            <section className="legal-block">
              <h2>2. Information We Collect</h2>
              <ul>
                <li>Name and company details</li>
                <li>Email address and phone number</li>
                <li>Messages submitted through contact forms</li>
                <li>Technical information such as IP address, browser type, device type, and pages visited</li>
                <li>Cookies and analytics data</li>
              </ul>
            </section>

            <section className="legal-block">
              <h2>3. How We Use Your Information</h2>
              <ul>
                <li>Respond to enquiries and provide support</li>
                <li>Deliver and improve our services</li>
                <li>Monitor website usage and performance</li>
                <li>Enhance user experience</li>
                <li>Comply with legal obligations</li>
                <li>Send account authentication, verification, security, and password recovery SMS messages.</li>

              </ul>
            </section>

              <section className="legal-block">
              <h2>4. 3A. SMS Communications and Account Verification</h2>
              <p>
                3A. SMS Communications and Account Verification

                Simba Solution and its Simba Express platform may send transactional SMS messages to users for account authentication, account verification, login verification, password recovery, security alerts, and other account-related purposes.

                These messages may include:

                <li>One-Time Passwords (OTP)</li>

                <li>Verification codes</li>

                <li>Login authentication codes</li>

                <li>Password reset codes</li>

                <li>Account security notifications</li>

                SMS messages are sent only when a user voluntarily provides their mobile phone number and initiates an action requiring verification, such as account registration, sign-in, account recovery, or account security validation.

                By providing a mobile phone number and requesting verification, users consent to receive these transactional SMS messages from Simba Express.

                Message and data rates may apply depending on the user's mobile carrier and service plan.

                These messages are not marketing or promotional messages and are sent solely for authentication, security, and account-related purposes.

                Users may reply STOP to opt out of SMS communications where applicable and HELP for assistance.

              </p>
            </section>

            <section className="legal-block">
              <h2>5. Cookies</h2>
              <p>
                Our website may use cookies and similar technologies to improve
                functionality, analyze traffic, and enhance the browsing experience.
                You can control cookies through your browser settings.
              </p>
            </section>

            <section className="legal-block">
              <h2>6. Data Sharing</h2>
              <p>
                We do not sell personal data. We may share information with
                trusted service providers, hosting providers, analytics providers,
                or authorities when required by law or necessary to provide our services.
              </p>
            </section>

            <section className="legal-block">
              <h2>7. Data Security</h2>
              <p>
                We apply reasonable technical and organizational safeguards to
                protect your information, although no system can be guaranteed to
                be completely secure.
              </p>
            </section>

            <section className="legal-block">
              <h2>8. Your Rights</h2>
              <p>
                Depending on applicable law, you may have rights to access,
                correct, delete, restrict, or object to the processing of your personal data.
              </p>
            </section>

            <section className="legal-block">
              <h2>9. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are not
                responsible for the privacy practices or content of those sites.
              </p>
            </section>

            <section className="legal-block">
              <h2>10. Changes to This Policy</h2>
              <p>
                For questions regarding SMS communications, privacy practices, or this Privacy Policy, please contact us at [support@simba-solution.com](mailto:support@simba-solution.com).
              </p>
            </section>

            <section className="legal-block">
              <h2>11. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please
                contact us through the contact section on our website.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
